<template>
    <div class="floor">
        <div class="floor__summary">
            <floor-image :floor="floor"/>

            <div class="floor__text">
                <h3 class="h3 floor__title">{{ floor.title }}</h3>
                <p class="floor__description" v-if="floor.description">{{ floor.description }}</p>
                <p class="overview__description">
                    <span class="overview__partials">
                        Patro <strong class="text--info">{{ floor.floorNumber }}</strong>
                    </span>
                </p>
                <div class="floor__description-controls">
                    <custom-button @click="update()" tabindex="-1" iconic>
                        <span icon edit></span>Upravit
                    </custom-button>
                    <custom-button @click="remove()" tabindex="-1" iconic>
                        <span icon remove></span>Odstranit
                    </custom-button>
                </div>
            </div>
        </div>
        <room-list :rooms="floor.rooms" :floor-id="floor.id"/>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import UpdateFloorDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Floor/UpdateFloorDialog';
import RoomList from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Room/RoomList';
import FloorImage from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Floor/FloorImage';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'FloorItem',
    components: {CustomButton, FloorImage, RoomList},
    props:      {
        floor: {
            type:     Object,
            required: true,
        }
    },
    methods:    {
        update() {
            this.$modal.show(UpdateFloorDialog, {floorId: this.floor.id}, defaultModalParameters());
        },
        remove() {
            const {id, title} = this.floor;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete patro <strong>' + title + '</strong> odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/floorPlan/removeFloor', id)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        }
    }
}
</script>
